var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"outlined":""},on:{"click":_vm.back}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v(_vm._s(_vm.$t('actions.back')))],1)}
var staticRenderFns = []

export { render, staticRenderFns }